let _ = require('lodash');
let moment = require('moment');
import { dateValueFormatter } from '../utils/format-date-cell';


/**
 * Extracts a display name from a value that may be a string, object, or array.
 * Handles hydrated user/party/entity objects from the backend.
 */
function extractName(value: any): string {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) {
        return value.map(v => extractName(v)).filter(n => n).join(', ');
    }
    if (typeof value === 'object') {
        if (value.friendlyName) return value.friendlyName;
        if (value.name) return value.name;
        if (value.email) return value.email;
        if (value.vendorData?.name) return value.vendorData.name;
        if (value.legalEntityData?.legalEntityName) return value.legalEntityData.legalEntityName;
    }
    return '';
}


export let colCoiNum = {colId: 'coiNum', headerName: 'Number', field: 'coiNum',width: 100, sortable: true};
export let colCoiId = {colId: 'coiId', headerName: 'Id', field: 'coiId',width: 100, sortable: true};


export let colMainDocumentName = {
  colId: 'mainDocumentName',
  headerName: 'Main Document Name',
  field: 'mainDocumentName',
  width: 150,
  sortable: true,
  filter: true
};

export let colInsuredName = {
                                colId: 'insuredName',
                                headerName: 'Insured Name',
                                field: 'insuredPartyFriendlyName',
                                width: 100,
                                sortable: true,
                                valueGetter: (params: any) => {
                                    const d = params.data;
                                    if (!d) return '';
                                    return d.insuredPartyFriendlyName || extractName(d.insuredParty) || '';
                                }
                            };


export let colCoverageType = {
                                colId: 'coverageType', 
                                headerName: 'Coverage Type(s)',
                                field: 'coverageTypes',
                                width: 100,
                                sortable: true
                            };


export let colEffectiveDate =   {
                                    colId: 'effectiveDate', 
                                    headerName: 'Effective Date',
                                    field: 'effectiveDate',
                                    width: 100,
                                    sortable: true,
                                    valueFormatter: dateValueFormatter
                                };

export let colExpirationDate = {
                                    colId: 'expirationDate',
                                    headerName: 'Expiration Date',
                                    field: 'expirationDate',
                                    width: 100,
                                    sortable: true,
                                    valueFormatter: dateValueFormatter
                                };

export let colInsuranceProvider =   {
                                        colId: 'insuranceProvider',
                                        headerName: 'Insurance Carrier',
                                        field: 'insuranceProviderNameDisplay',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const d = params.data;
                                            if (!d) return '';
                                            if (d.insuranceProviderNameDisplay) return d.insuranceProviderNameDisplay;
                                            const provider = d.insuranceProvider;
                                            if (!provider) return '';
                                            if (Array.isArray(provider)) return provider.map(p => extractName(p)).filter(n => n).join(', ');
                                            return extractName(provider);
                                        }
                                    };

export let colVersion =   {
                                        colId: 'version',
                                        headerName: 'Version',
                                        field: 'version',
                                        width: 50,
                                        sortable: true
                                    };

export let colDescription = {
                                colId: 'description', 
                                headerName: 'Description',
                                field: 'description',
                                width: 100,
                                sortable: true
                            };

export let colPartyProvidingCoi = {
                                    colId: 'partyProvidingCoi',
                                    headerName: 'Party Providing COI',
                                    field: 'partyProvidingCoiFriendlyName',
                                    width: 100,
                                    sortable: true,
                                    valueGetter: (params: any) => {
                                        const d = params.data;
                                        if (!d) return '';
                                        return d.partyProvidingCoiFriendlyName || extractName(d.partyProvidingCoi) || '';
                                    }
                                };

export let colParentParty = {
                                colId: 'parentParty',
                                headerName: 'Parent Party',
                                field: 'parentParty.name',
                                width: 100,
                                sortable: true
                            };

export let colLegalEntity =     {
                                    colId: 'legalEntity',
                                    headerName: 'Legal Entity',
                                    field: 'legalEntityFriendlyName',
                                    width: 100,
                                    sortable: true,
                                    valueGetter: (params: any) => {
                                        const d = params.data;
                                        if (!d) return '';
                                        if (d.legalEntityFriendlyName) return d.legalEntityFriendlyName;
                                        const le = d.legalEntities;
                                        if (!le) return '';
                                        if (Array.isArray(le)) {
                                            return le.map((e: any) => {
                                                if (typeof e === 'string') return e;
                                                return e?.legalEntityData?.legalEntityName || e?.name || e?.friendlyName || '';
                                            }).filter((n: string) => n).join(', ');
                                        }
                                        return extractName(le);
                                    }
                                };
export let colSites =   {
                            colId: 'sites',
                            headerName: 'Sites',
                            field: 'sitesFriendlyName',
                            width: 100,
                            sortable: true
                        };
export let colStatus = {colId: 'status', headerName: 'Status', field: 'status',width: 100, sortable: true };
export let colDepartments = {colId: 'departments', headerName: 'Departments', field: 'departments',width: 100, sortable: true };
export let colCarrierSignatory = {colId: 'carrierSignatory', 
                                    headerName: 'Carrier Signatory', field: 'carrierSignatoryFriendlyName',width: 100, sortable: true };
export let colLastReview =  {
                                colId: 'lastReview',
                                headerName: 'Last Review',
                                field: 'lastReviewDate',
                                width: 100,
                                sortable: true,
                                filter: 'agDateColumnFilter',
                                filterParams: {comparator: dateComparator},
                                comparator: dateComparator,
                                valueFormatter: dateValueFormatter
                            };

export let colNextReview =  {
                                colId: 'nextReview',
                                headerName: 'Next Review',
                                field: 'nextReviewDate',
                                width: 100,
                                sortable: true,
                                filter: 'agDateColumnFilter',
                                filterParams: {comparator: dateComparator},
                                comparator: dateComparator,
                                valueFormatter: dateValueFormatter
                            };

export let colPrimaryOwner =    {
                                    colId: 'primaryOwner',
                                    headerName: 'Primary Owner',
                                    field: 'primaryOwnerFriendlyName',
                                    width: 100,
                                    sortable: true,
                                    valueGetter: (params: any) => {
                                        const d = params.data;
                                        if (!d) return '';
                                        return d.primaryOwnerFriendlyName || extractName(d.primaryOwner) || '';
                                    }
                                };

export let colSecondaryOwner =  {
                                    colId: 'secondaryOwner',
                                    headerName: 'Secondary Owner',
                                    field: 'secondaryOwnerFriendlyName',
                                    width: 100,
                                    sortable: true,
                                    valueGetter: (params: any) => {
                                        const d = params.data;
                                        if (!d) return '';
                                        return d.secondaryOwnerFriendlyName || extractName(d.secondaryOwner) || '';
                                    }
                                };

export let colTertiaryOwner =   {
                                    colId: 'tertiaryOwner',
                                    headerName: 'Tertiary Owner',
                                    field: 'tertiaryOwnerFriendlyName',
                                    width: 100,
                                    sortable: true
                                };

export let colInternalCoordinator = {
                                        colId: 'internalCoordinator',
                                        headerName: 'Internal COI Coordinator',
                                        field: 'internalCoordinatorFriendlyName',
                                        width: 100,
                                        sortable: true
                                    };

export let colExternalCoordinator = {
                                        colId: 'externalCoordinator',
                                        headerName: 'External COI Coordinator',
                                        field: 'externalCoordinatorFriendlyName',
                                        width: 100,
                                        sortable: true
                                    };

export let colRiskScore =   {
                                colId: 'riskScore',
                                headerName: 'Risk Score',
                                field: 'paymentTerms',
                                width: 100,
                                sortable: true,
                                valueFormatter: riskFormatter
                            };



export let allColumns = [

    colCoiNum,
    colCoiId,
    colMainDocumentName,
    colInsuredName,
    colCoverageType,
    colEffectiveDate,
    colExpirationDate,
    colInsuranceProvider,
    colDescription,
    colPartyProvidingCoi,
    colLegalEntity,
    colSites,
    colStatus,
    colDepartments,
    colLastReview,
    colNextReview,
    colPrimaryOwner,
    colSecondaryOwner,
    colTertiaryOwner,
    colInternalCoordinator,
    colExternalCoordinator,
];






export let columnSelectList = [
    {
        value: colCoiId,
        viewValue: colCoiId.headerName
    },
    {
        value: colCoiNum,
        viewValue: colCoiNum.headerName
    },
    {
        value: colMainDocumentName,
        viewValue: colMainDocumentName.headerName
    },
    {
        value: colInsuredName,
        viewValue: colInsuredName.headerName
    },
    {
        value: colCoverageType,
        viewValue: colCoverageType.headerName
    },
    {
        value: colEffectiveDate,
        viewValue: colEffectiveDate.headerName
    },
    {
        value: colExpirationDate,
        viewValue: colExpirationDate.headerName
    },
    {
        value: colInsuranceProvider,
        viewValue: colInsuranceProvider.headerName
    },
    {
        value: colDescription,
        viewValue: colDescription.headerName
    },
    {
        value: colPartyProvidingCoi,
        viewValue: colPartyProvidingCoi.headerName
    },

    {
        value: colLegalEntity,
        viewValue: colLegalEntity.headerName
    },
    {
        value: colSites,
        viewValue: colSites.headerName
    },
    {
        value: colStatus,
        viewValue: colStatus.headerName
    },
    {
        value: colDepartments,
        viewValue: colDepartments.headerName
    },
    {
        value: colLastReview,
        viewValue: colLastReview.headerName
    },
    {
        value: colNextReview,
        viewValue: colNextReview.headerName
    },
    {
        value: colPrimaryOwner,
        viewValue: colPrimaryOwner.headerName
    },
    {
        value: colSecondaryOwner,
        viewValue: colSecondaryOwner.headerName
    },
    {
        value: colTertiaryOwner,
        viewValue: colTertiaryOwner.headerName
    },
    {
        value: colInternalCoordinator,
        viewValue: colInternalCoordinator.headerName
    },
    {
        value: colExternalCoordinator,
        viewValue: colExternalCoordinator.headerName
    },
];


function riskFormatter(param) {

    // console.log('riskFormatter: ', param.data.riskScore);

    let scoreAsNumber = Number(param.data.riskScore);
    let scoreAsFloat = scoreAsNumber.toFixed(1);

    // console.log('scoreAsFloat: ', scoreAsFloat);

    if ((scoreAsFloat != undefined) &&
        (scoreAsFloat != 'NaN')) {
      return scoreAsFloat;
    } else {
      return '';
    }
  }




function dateComparator(date1, date2) {

    if (date1 === null && date2 === null) {
          return 0;
    }

    if (date1 === null || date1 === undefined || date1 === '') {
        return -1;
    }

    if (date2 === null || date2 === undefined || date2 === '') {
        return 1;
    }    

    let date1AsMoment = moment(date1);
    let date2AsMoment = moment(date2);
    // let date1AsMoment = moment(date1, ["MM-DD-YYYY", "M-D-YYYY", "MM/DD/YYYY"]);
    // let date2AsMoment = moment(date2, ["MM-DD-YYYY", "M/D/YYYY", "MM/DD/YYYY"]);

    if (date1AsMoment.isValid() && date2AsMoment.isValid()) {

        // console.log(date1);

        if (date1AsMoment.isBefore(date2AsMoment)) {
            return -1;
        } else {
            return 1;
        }

    } else {
        // I don't know what this case means.
        console.warn('******* something is not a date');
        console.log(date1);
        console.log(date2);
        return 0;
    }

}